/** Journey只接受这些固定的展示键；原v1记录可以缺少后来新增的键。 */
export const WORKSHEET_CARD_SELECTORS: Record<string, string> = {
  cost_split: ".fq-cost-split details",
  cost_structure: ".fq-cost-structure details",
  pricing: ".fq-pricing-adjust details",
  nre: ".fq-nre details",
  commercial: ".fq-commercial details",
  part_blank: 'details[data-quote-section="part_blank"]',
  material: 'details[data-quote-section="material"]',
  process: 'details[data-quote-section="process"]',
  surface: 'details[data-quote-section="surface"]',
  logistics: 'details[data-quote-section="logistics"]',
  analysis: 'details[data-quote-section="analysis"]',
};
